import React, { useState, useEffect } from 'react';
import progress from '../images/progress.png';
import '../styles/transactions.css';
import { doc, getDoc } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { db } from '../lib/firebase';

const Verification = ({ setShowVerificationBox }) => {
    const [code, setCode] = useState('');
    const [userInputCode, setUserInputCode] = useState('');
    const [verificationMessage, setVerificationMessage] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [report, setReport] = useState(''); // State for user report


    useEffect(() => {
        const fetchUserCode = async () => {
            try {
                const auth = getAuth();
                const userId = auth.currentUser?.uid;

                if (!userId) {
                    setVerificationMessage('User is not logged in. Please log in to verify.');
                    setIsLoading(false);
                    return;
                }

                const userDoc = await getDoc(doc(db, 'swiss-h', userId));

                if (userDoc.exists()) {
                    const userData = userDoc.data();
                    setCode(userData.code || ''); // Set code if it exists
                    setReport(userData.report || 'No report available.'); // Set report


                    if (userData.code) {
                        // Fetch 'code' from Firestore
                        setCode(userData.code);
                    } else {
                        setVerificationMessage('Verification code is unavailable. Please contact support.');
                    }
                } else {
                    setVerificationMessage('User not found.');
                }
            } catch (error) {
                setVerificationMessage('Error fetching user data. Please try again later.');
                console.error('Error fetching user code:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchUserCode();
    }, []);

    const handleVerificationSubmit = (e) => {
        e.preventDefault();

        if (!code) {
            setVerificationMessage('Verification code is unavailable. Please contact support.');
            return;
        }

        if (userInputCode.trim() === code.trim()) {
            setVerificationMessage('Verification successful! Your transactions will be processed.');
        } else {
            setVerificationMessage('Invalid code. Please try again.');
        }
    };

    return (
        <div className="overlaid">
            <div className='verification-container'>
                <div className="verification-box">
                    <h3>Verify Transactions</h3>
                    {/* Show loading image while fetching data */}
                    <div className='balanceSection'>{report}</div>
                    {isLoading ? (
                        <>
                            <div className="center-container">
                                <img
                                    src={progress}
                                    alt="Loading"
                                    className="transferIMG"
                                />
                            </div>
                            <div className="center-text">Verification Requirements Loading</div>
                        </>

                    ) : (
                        <>
                            {verificationMessage && <p>{verificationMessage}</p>}
                            <form onSubmit={handleVerificationSubmit}>
                                <div className="center-container">
                                    <img
                                        src={progress}
                                        alt="Loading"
                                        className="transferIMG"
                                    />
                                </div>
                                <input
                                    type="text"
                                    value={userInputCode}
                                    className='input-field'
                                    onChange={(e) => setUserInputCode(e.target.value)}
                                    placeholder="Enter verification code"
                                    required
                                />
                                <div className="button-container">
                                    <button type="submit" className='closed'>
                                        Submit
                                    </button>


                                    <button
                                        type="button"
                                        className='contact-support-button'
                                        onClick={() => setShowVerificationBox(false)}
                                    >
                                        Close
                                    </button>

                                </div>
                            </form>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Verification;
